import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const boxy = defineStyle({
  borderRadius: 'full',
  fontWeight: 'semibold',
  fontsize: 'xl',
  fontSize: '2xs',
  py: 1,
  px: 2,
});

export const badgeTheme = defineStyleConfig({
  variants: { subtle: boxy },
});
